/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ScheduleTransferStatus {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled',
}